import React, {useEffect} from 'react';
import {SearchCommandInput, TrackingTargetProviderEnum} from '@kidslabs/mario-client-event-tracking';
import {PageType} from '@/_application/core/types';
import useEventTrackingService from '@/_application/modules/tracking/service/event-tracking.service';
import isEqual from 'lodash/isEqual';

interface SearchTrackingProps {
    page: PageType;
    input: SearchCommandInput;
}
const SearchTracking = ({page, input}: SearchTrackingProps) => {
    const {trackSearchEvent: trackGoogle} = useEventTrackingService(TrackingTargetProviderEnum.GOOGLE_ANALYTICS);
    const {trackSearchEvent: trackFacebook} = useEventTrackingService(TrackingTargetProviderEnum.FACEBOOK_PIXEL);
    const {trackSearchEvent: trackCdp} = useEventTrackingService(TrackingTargetProviderEnum.CDP);

    useEffect(() => {
        trackGoogle(input).then(() => {});
        trackFacebook(input).then(() => {});
        trackCdp(input).then(() => {});
    }, [page, input.search_string]);

    return <></>;
};

const arePropsEqual = (prevProps: SearchTrackingProps, nextProps: SearchTrackingProps) => {
    return isEqual(prevProps.input.search_string, nextProps.input.search_string) && prevProps.page === nextProps.page;
};
const SearchTrackingComponent = React.memo(SearchTracking, arePropsEqual);

export {SearchTrackingComponent as SearchTracking};
